import { render, staticRenderFns } from "./SalonOrderSelect.vue?vue&type=template&id=b0aa4434&scoped=true&"
import script from "./SalonOrderSelect.vue?vue&type=script&lang=js&"
export * from "./SalonOrderSelect.vue?vue&type=script&lang=js&"
import style0 from "./SalonOrderSelect.vue?vue&type=style&index=0&id=b0aa4434&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0aa4434",
  null
  
)

export default component.exports